import { useQuery } from '@tanstack/react-query';
import { getOrdersByIdService } from '@/services';

type Callbacks = {
  onSuccess?: (data?: any) => void;
};

export const useCurrentOrder = (current?: any, callbacks?: Callbacks) => {
  const { data } = useQuery({
    queryKey: ['orders', current?.id],
    queryFn: () => getOrdersByIdService(current.id),
    select: (response) => {
      const ordersDetailsHashMap =
        response?.ordersDetails?.reduce((acc: any, item: any) => {
          acc[item.id] = item;
          return acc;
        }, {}) ?? {};
      callbacks?.onSuccess?.(response);
      return { data: response, ordersDetailsHashMap };
    },
  });

  return { currentOrder: current, ...data };
};
